import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Awards from "../components/Awards";
import CoffeeEstate from "../components/CoffeeEstate";
import SwimmingPool from "../components/SwimmingPool";
import {
    DiningHall,
    MalnadFood,
    LivingMuseum,
    BottleGallery,
    ActivitiesSection,
    RentStrip,
} from "../components/Sections";
import Rooms from "../components/Rooms";
import Events from "../components/Events";
import Reviews from "../components/Reviews";
import Nearby from "../components/Nearby";
import InquiryForm from "../components/InquiryForm";
import LocationMap from "../components/LocationMap";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import { Toaster } from "sonner";

export default function LandingPage() {
    return (
        <div className="bg-cream text-coffee-900" data-testid="landing-page">
            <Navbar />
            <main>
                <Hero />
                <Awards />
                <CoffeeEstate />
                <SwimmingPool />
                <DiningHall />
                <MalnadFood />
                <LivingMuseum />
                <BottleGallery />
                <ActivitiesSection />
                <Rooms />
                <Events />
                <RentStrip />
                <Reviews />
                <Nearby />
                <InquiryForm />
                <LocationMap />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <Toaster position="top-center" richColors />
        </div>
    );
}
